var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c(
                "b-form",
                {
                  staticClass: "row",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.doFilter($event)
                    }
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("el-input", {
                        staticClass: "input-primary",
                        attrs: {
                          placeholder: "Filter dengan kode",
                          clearable: ""
                        },
                        model: {
                          value: _vm.tableFilter.kode,
                          callback: function($$v) {
                            _vm.$set(_vm.tableFilter, "kode", $$v)
                          },
                          expression: "tableFilter.kode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "large",
                            clearable: "",
                            placeholder: "Filter dengan status"
                          },
                          model: {
                            value: _vm.tableFilter.status,
                            callback: function($$v) {
                              _vm.$set(_vm.tableFilter, "status", $$v)
                            },
                            expression: "tableFilter.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: null, label: "Semua Status" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 0, label: "Pending" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 1, label: "Lunas" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 2, label: "Tahan" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 3, label: "Batal" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 4, label: "Draft" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          placeholder: "Pick a range"
                        },
                        model: {
                          value: _vm.tableFilter.date,
                          callback: function($$v) {
                            _vm.$set(_vm.tableFilter, "date", $$v)
                          },
                          expression: "tableFilter.date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "1" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "search" } }),
                        _vm._v(" Search")
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("create-new-data", {
                attrs: { "data-url": "/penjualan/create", clearfix: false }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("paginated-table", {
        ref: "dataTable",
        attrs: {
          "can-delete": false,
          "can-print": true,
          "can-edit": false,
          "param-no-uuid": true,
          "no-actions": false,
          "active-url": _vm.apiUrl,
          "data-url": _vm.apiUrl,
          "data-key": _vm.dataKey,
          "data-columns": _vm.columns,
          "data-params": [
            "is_active",
            "kode",
            "status",
            "start_date",
            "end_date"
          ]
        },
        scopedSlots: _vm._u([
          {
            key: "content_created_by",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#/users/" + defaultSlotScope.rowData.created_by.id
                    }
                  },
                  [_vm._v(_vm._s(defaultSlotScope.rowData.created_by.name))]
                )
              ]
            }
          },
          {
            key: "content_status",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "b-badge",
                  {
                    attrs: {
                      variant: _vm.getStatusColor(
                        defaultSlotScope.rowData.status
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getStatus(defaultSlotScope.rowData.status))
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "content_customer",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "#/pengaturan/customer/" +
                        defaultSlotScope.rowData.customer.id
                    }
                  },
                  [_vm._v(_vm._s(defaultSlotScope.rowData.customer.name))]
                )
              ]
            }
          },
          {
            key: "content_last_updated_by",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "#/users/" + defaultSlotScope.rowData.last_updated_by.id
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(defaultSlotScope.rowData.last_updated_by.name)
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "content_total",
            fn: function(defaultSlotScope) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatNumber(defaultSlotScope.rowData.total)) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb0ce69c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb0ce69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Orders/Index.vue
// module id = 5M9y
// module chunks = 4